module.exports = __webpack_public_path__ + "img/Group 58@2x.06497f84.png";